import { useCallback, useState } from "react";
import { STATUS } from "../domain/mediaUpload";
import useSocket from "./useSocket";

// Keyed by what the upload was for rather than by upload id: the page that
// cares is an order row, which knows the reference and not the id.
const useMediaUploadOutcome = ({ uploadType, referenceId, onComplete }) => {
  const [outcome, setOutcome] = useState(null);

  const matches = useCallback(
    (data) =>
      Boolean(referenceId) &&
      data?.uploadType === uploadType &&
      data?.referenceId === referenceId,
    [uploadType, referenceId],
  );

  const handleComplete = useCallback(
    (data) => {
      if (!matches(data)) return;

      setOutcome({ status: STATUS.COMPLETE, error: null });
      onComplete?.(data);
    },
    [matches, onComplete],
  );

  const handleError = useCallback(
    (data) => {
      if (!matches(data)) return;

      setOutcome({
        status: STATUS.FAILED,
        error: data.error,
        errorClassification: data.errorClassification,
        errorCode: data.errorCode ?? null,
        errorLimit: data.errorLimit ?? null,
        mediaUploadId: data.mediaUploadId,
      });
    },
    [matches],
  );

  useSocket(referenceId ? "mediaUpload:complete" : null, handleComplete);
  useSocket(referenceId ? "mediaUpload:error" : null, handleError);

  return { outcome, clear: useCallback(() => setOutcome(null), []) };
};

export default useMediaUploadOutcome;
